import { ChangeDetectorRef, Component, Input, OnInit, TemplateRef, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'ad-doc-viewer',
  templateUrl: './ad-doc-viewer.component.html',
  styleUrls: ['./ad-doc-viewer.component.scss']
})
export class AdDocViewerComponent implements OnInit, OnChanges {
  @Input() fileSrc: string = "";
  @Input() fileExtension: string = "";
  @Input() documentId: number;
  @Input() subHeaderTemplate: TemplateRef<any>;
  @Input() itemGetter: (id: number) => Observable<{ img: string, width: number, height: number }[]>;
  @Input() downloadFun: (id: number) => void;
  @Input() excelPrintFun: (id: number) => Observable<{ img: string, width: number, height: number }[]>;
  @Input() validator: (id: number, extension: string) => Observable<boolean>;
  @ViewChild("viewer", { static: false }) viewer: any;
  excelPrintLoading = false;
  isValid: boolean = false;
  isLoading: boolean = true;
  noFile: boolean = false;
  @Input() fileExists: (id: number, extension: string) => Observable<boolean>;
  @Input()
  enablePrint = true;
  @Input()
  enableDownload = true;

  imgViewerExtensions = [".doc", ".docx", ".ppt", ".pptx"];
  documentExtensionList = [
    '.pdf',
    '.xls',
    '.xlsx',
    '.doc',
    '.docx',
    ".ppt",
    ".pptx",
    "youtube",
    "vimeo"
  ];

  get isHideZoom() {
    return this.isExcel;
  }

  get isExcel() {
    return [".xls", ".xlsx"].indexOf(this.fileExtension) !== -1;
  }

  get isPdf() {
    return [".pdf"].indexOf(this.fileExtension) !== -1;
  }

  @Input()
  videoUrl: string;

  constructor(private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.existFile();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes["fileSrc"] && changes["fileSrc"].previousValue !== undefined) || (changes["fileExtension"] && changes["fileExtension"].previousValue !== undefined) || (changes["documentId"] && changes["documentId"].previousValue !== undefined)) {
      this.existFile();
    }
  }

  existFile() {
    if (this.fileExists) {
      this.fileExists(this.documentId, this.fileExtension).subscribe((data: boolean) => {
        this.noFile = !data;
        if (this.noFile === true) {
          this.isValid = true;
          this.isLoading = false;
          this.cd.detectChanges();
        } else {
          this.validate();
        }
      });
    } else {
      this.validate();
    }
  }

  validate() {
    if (this.validator) {
      this.validator(this.documentId, this.fileExtension).subscribe((data: boolean) => {
        this.isValid = data;
        this.isLoading = false;
        this.noFile = false;
        this.cd.detectChanges();
      })
    } else {
      this.noFile = false;
      this.isValid = true;
      this.isLoading = false;
      this.cd.detectChanges();
    }
  }

  zoomOut() {
    if (this.viewer && this.viewer["zoomOut"]) {
      this.viewer.zoomOut();
    }
  }

  zoomIn() {
    if (this.viewer && this.viewer["zoomIn"]) {
      this.viewer.zoomIn();
    }
  }

  print() {
    if (this.isExcel && this.excelPrintFun) {
      this.excelPrintLoading = true;
      this.excelPrintFun(this.documentId).subscribe(pages => {
        this.printExcel(pages);
        this.excelPrintLoading = false;
      });
    } else if (this.isPdf) {
      if (this.viewer && this.viewer["print"]) {
        this.viewer.print();
      }
    } else {
      if (this.viewer && this.viewer["print"]) {
        this.excelPrintLoading = true;
        this.viewer.print().subscribe((items) => {
          this.viewer.doPrint(items);
          this.excelPrintLoading = false;
        });
      }
    }
  }

  download() {
    if (this.downloadFun) {
      this.downloadFun(this.documentId);
    }
  }

  public printExcel(pages) {
    let printContents = "", popupWin;
    //printContents = this.mainContent.nativeElement.innerHTML;
    pages.forEach(item => {
      printContents += `<div><img src="${item.img}" style="width:${item.width}px;height:${item.height}px"/></div>`;
    })
    popupWin = window.open('http://' + window.location.host + window.location.pathname, '_blank');
    setTimeout(() => {

      popupWin.document.write(`
  <html>
    <head>
      <title></title>
      <style></style>
      <script>
        function printFun(){
          window.print();
          setTimeout(function(){
            window.close();
          },10)
        }
      </script>
    </head>
<body onload="printFun();">
    <div>${printContents}</div>
</body>
  </html>`
      );
      popupWin.document.close();
    }, 10)
  }

  enableDefaultViewer() {
    if (this.documentExtensionList.indexOf(this.fileExtension) > -1) {
      return false;
    }
    return true;
  }

}
